import { type } from '@/utils/type'


export const MISSIONPLANTEMPLATE_REQUEST = type('MISSIONPLANTEMPLATE_REQUEST')
export const MISSIONPLANTEMPLATE_SUCCESS = type('MISSIONPLANTEMPLATE_SUCCESS')
export const MISSIONPLANTEMPLATE_ERROR = type('MISSIONPLANTEMPLATE_ERROR')

export const MISSIONPLANTEMPLATE_ENSURE_LIST = type('MISSIONPLANTEMPLATE_ENSURE_LIST')

export const MISSIONPLANTEMPLATE_SELECT_DETAIL_REQUEST = type('MISSIONPLANTEMPLATE_SELECT_DETAIL_REQUEST')
export const MISSIONPLANTEMPLATE_SELECT_DETAIL_SUCCESS = type('MISSIONPLANTEMPLATE_SELECT_DETAIL_SUCCESS')
export const MISSIONPLANTEMPLATE_SELECT_DETAIL_ERROR = type('MISSIONPLANTEMPLATE_SELECT_DETAIL_ERROR')
export const MISSIONPLANTEMPLATE_SELECT_DETAIL = type('MISSIONPLANTEMPLATE_SELECT_DETAIL')

export const MISSIONPLANTEMPLATE_DELETE_REQUEST = type('MISSIONPLANTEMPLATE_DELETE_REQUEST')
export const MISSIONPLANTEMPLATE_DELETE_SUCCESS = type('MISSIONPLANTEMPLATE_DELETE_SUCCESS')
export const MISSIONPLANTEMPLATE_DELETE_ERROR = type('MISSIONPLANTEMPLATE_DELETE_ERROR')

export const MISSIONPLANTEMPLATE_SAVE_REQUEST = type('MISSIONPLANTEMPLATE_SAVE_REQUEST')
export const MISSIONPLANTEMPLATE_SAVE_SUCCESS = type('MISSIONPLANTEMPLATE_SAVE_SUCCESS')
export const MISSIONPLANTEMPLATE_SAVE_ERROR = type('MISSIONPLANTEMPLATE_SAVE_ERROR')

export const MISSIONPLANTEMPLATE_UPDATE_MODIFIED_ADM = type('MISSIONPLANTEMPLATE_UPDATE_MODIFIED_ADM')
export const MISSIONPLANTEMPLATE_CANCEL_MODIFIED_ADM = type('MISSIONPLANTEMPLATE_CANCEL_MODIFIED_ADM')

export const MISSIONPLANTEMPLATE_UPDATE_FILTER_ADM = type('MISSIONPLANTEMPLATE_UPDATE_FILTER_ADM') 